import RailwayAlertIcon from '@mui/icons-material/RailwayAlert';

const StationTypeIcon = (props) => {
    const {...other} = props;
    return (
        <RailwayAlertIcon {...other}/>
    )
}

export default StationTypeIcon;